export default __webpack_public_path__ + "static/media/emailmailmarkunreadlocal_post_office.2c1a422b.svg";